import { render, staticRenderFns } from "./PaymentReferences.vue?vue&type=template&id=0fc65a6b"
import script from "./PaymentReferences.vue?vue&type=script&lang=js"
export * from "./PaymentReferences.vue?vue&type=script&lang=js"
import style0 from "./PaymentReferences.vue?vue&type=style&index=0&id=0fc65a6b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports